// Should stay in sync with checkpoint-document-types-privileged-only.mjs

import { MDDAP_CHECK_POINTDOCUMENT_TYPES } from './mddap-checkpoint-document-types';

export const CHECKPOINT_DOCUMENT_TYPES_PRIVILEGED_ONLY = [
  MDDAP_CHECK_POINTDOCUMENT_TYPES.CheckPointReport,
  MDDAP_CHECK_POINTDOCUMENT_TYPES.ReappraisalRationale
];
